import Scrollbars from "Components/scrollbars";
import WelcomePanel from "Components/welcomePanel";
import map from "lodash/map";
import React from "react";
import ProjectDetails from "./projectDetails";
import locale from "./projectList.locale";
export default function ProjectList(props) {
    var _a;
    return (React.createElement("div", { className: "h-100 grid-rows-auto-1fr" }, ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) === 0 ? (React.createElement(WelcomePanel, { messageClassName: "font-base", showIcon: false, message: locale.NO_DATA_TEXT })) : (React.createElement(Scrollbars, null,
        React.createElement("div", { className: "flex-single-column with-grid-spaces" }, map(props.data, project => (React.createElement(ProjectDetails, { key: project.Id, project: project }))))))));
}
